import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import { Modal } from '@shared/ui/Overlays/Modal'
import s from './SuccessfulRegistrationModal.module.sass'
import Img from '@images/restorator/successfulSend.jpg'
import ImgMobile from '@images/restorator/successfulSendMobile.jpg'
import Image from 'next/image'
import React from 'react'
import { Button } from '@shared/ui/Actions/Button'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'

interface Props {
  email: string
  onClose: () => void
}

export const SuccessfulRegistrationModal = ({ email, onClose }: Props) => {
  const { isMobile } = useClientResponsive()

  return (
    <>
      {email && (
        <ErrorBoundary>
          <Modal
            title={
              <>
                В ближайшее время отправим&nbsp;счет{isMobile ? ' ' : <>&nbsp;</>}на&nbsp;оплату на{' '}
                <a href={`mailto:${email}`} className={s['mail-link']}>
                  {email}
                </a>
              </>
            }
            titleSizes='h1 h3'
            handleClose={onClose}
            size='L'
            className={s.bottomless}>
            <div className={s.content}>
              {isMobile && <Image src={ImgMobile.src} alt='Промо' width={332.4} height={350} quality={100} />}

              <Button sizes='XL' mode='black' onClick={onClose} className={s.button}>
                Ясно
              </Button>

              {!isMobile && (
                <Image src={Img.src} alt='Промо' width={810} height={320} quality={100} className={s['weird-image']} />
              )}
            </div>
          </Modal>
        </ErrorBoundary>
      )}
    </>
  )
}
